// extracted by mini-css-extract-plugin
export default {"root":"bQl2P","mobile":"UNJJ4","iconContainer":"ySW0D","tab":"rx6MF","selected":"Wnlvs","maskedIcon":"Mdpt7","hidden":"m5NNV","activeIcon":"muX_v","fallbackIcon":"aTJnB"};